import React, { FC, useState } from "react"
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { QuestionProps } from '../../../typings/register';
import { RootState } from "../../../redux/store";
import QuestionUpdateHeader from "./QuestionUpdateHeader";
import { useDispatch } from 'react-redux';
import { setUserData } from "../../../redux/member";
import EditLocation from "../../../components/EditLocation";
import { LocationAutocompleteType } from "../../../typings/google";
import { updateMemberLocationPlace } from "../../../services/memberService";
import { CitySuggestion } from "../../Signup/components/LocationQuestion";
import { GenderType } from "../../../helpers/Enums";

const UpdateLocation: FC = () => {
    const [question, setQuestion] = useState<QuestionProps>();
    const member = useSelector((state: RootState) => state.member);
    let history = useHistory();
    const dispatch = useDispatch();


    const onSave = async (selectedLocation: CitySuggestion) => {
        await updateMemberLocationPlace(member.memberCode, selectedLocation.id);
        dispatch(setUserData({ ...member, city: selectedLocation.cityName }))
        history.goBack();
    };


    return (
        <>
            <QuestionUpdateHeader />
            <EditLocation
                buttonText={"שמור"}
                subtitle={member.genderId == GenderType.MALE ? "ככל שתדייק את מיקומך תוכל לראות משתמשים אחרים בסביבתך." : "ככל שתדייקי את מיקומך תוכלי לראות משתמשים אחרים בסביבתך."}
                title={member.genderId == GenderType.MALE ? "מאיפה אתה" : "מאיפה את"}
                value={undefined} onSave={onSave}
                preLocation={member.city}
            />
        </>
    )
}

export default UpdateLocation
